import { render, staticRenderFns } from "./CouponVipPopupCustomer.vue?vue&type=template&id=a1bbc87a&scoped=true&"
import script from "./CouponVipPopupCustomer.vue?vue&type=script&lang=js&"
export * from "./CouponVipPopupCustomer.vue?vue&type=script&lang=js&"
import style0 from "./CouponVipPopupCustomer.vue?vue&type=style&index=0&id=a1bbc87a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1bbc87a",
  null
  
)

export default component.exports